import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { postsAPI } from '../../services/api';
import VideoModal from '../VideoModal/VideoModal';

const VideoModalRoute = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [video, setVideo] = useState(null);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const res = await postsAPI.getById(slug);
        if (!cancelled) setVideo(res.data);
      } catch (e) {
        if (!cancelled) setVideo(null);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [slug]);

  if (!video) return null;

  return <VideoModal video={video} onClose={() => navigate(-1)} />;
};

export default VideoModalRoute;
